module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_Black.491e21f3.jpg";